import React, { useState, useEffect } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";

function DropdownNamesSetup() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  //   const savedCenterId =
  //     localStorage.getItem("centerId") === "null"
  //       ? null
  //       : localStorage.getItem("centerId");

  const [triggerRerender, setTriggerRerender] = useState(false);

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    setError,
  } = useForm({
    defaultValues: {
      id: 0,
      moduleName: "",
      organizationId: organizationId,
      createdBy: localStorage.getItem("userId"),
    },
  });

  //   const [selectedCenterId, setSelectedCenterId] = useState(
  //     savedCenterId || null
  //   );
  const [dropdownNames, setDropdownNames] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  // For SearchBar..
  const filteredDropdownNames = dropdownNames.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return item.moduleName.toLowerCase().includes(searchLower);
  });

  //   useEffect(() => {
  //     const fetchCenters = async () => {
  //       try {
  //         const response = await get(
  //           `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );
  //         setCentersData(response);
  //         if (savedCenterId) {
  //           const selectedCenter = response.find(
  //             (center) => center.id === parseInt(savedCenterId, 10)
  //           );
  //           if (selectedCenter) {
  //             setValue("centerId", {
  //               value: selectedCenter.id,
  //               label: selectedCenter.name,
  //             });
  //           }
  //         }
  //       } catch (error) {
  //         console.error("Error fetching centers:", error);
  //       }
  //     };

  //     fetchCenters();
  //   }, [savedCenterId]);

  const getDropdownNamesByOrgId = async () => {
    try {
      const response = await get(`CommonSettings/GetCommonSettingByAsync`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setDropdownNames(response?.commonSetting);
    } catch (error) {
      console.error("Error fetching dropdowns:", error);
    }
  };

  useEffect(() => {
    getDropdownNamesByOrgId();
  }, [triggerRerender]);

  const handleEdit = async (row) => {
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingById?id=${row.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const singleItem = response?.commonSetting;

      reset({
        id: singleItem.id || "",
        moduleName: singleItem.moduleName || "",
        organizationId:
          singleItem.organizationId || localStorage.getItem("organizationId"),
        createdBy: singleItem.createdBy || "",
        updatedBy: localStorage.getItem("userId"),
      });
    } catch (error) {
      console.error("Error editing:", error);
    }
  };

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      //   width: "60px",
    },
    {
      name: "Dropdown Name",
      selector: (row) => row.moduleName,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          <button
            type="button"
            className="btn p-0"
            onClick={() => handleEdit(row)}
          >
            <i className="fas fa-pencil"></i>
          </button>
        </div>
      ),
    },
  ];

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await post(
        "CommonSettings/AddUpdateCommonSetting",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        reset({
          id: 0,
          moduleName: "",
          organizationId: organizationId,
          createdBy: localStorage.getItem("userId"),
        });
      } else {
        toast.error(response.message || "An unexpected error occurred");
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <div className="">
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Dropdown Names</h2>
      </div>

      <div className="row g-3">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <form className="row g-3" onSubmit={handleSubmit(saveData)}>
                {/* <div className="col-md-6">
                  <label className="form-label">
                    Center<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="centerId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        // isDisabled={!!savedCenterId}
                        isDisabled={savedCenterId !== "0"}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("centerId", null);
                            setValue("centerClassId", null);
                            setClassesData([]);
                            setSelectedCenterId(null);
                          } else {
                            setValue("centerId", selectedOption);
                            setValue("centerClassId", null);
                            setSelectedCenterId(selectedOption.value);
                            fetchClassesByCenterId(selectedOption.value);
                          }
                          trigger("centerId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable={
                          savedCenterId !== null && savedCenterId !== 0
                        }
                      />
                    )}
                  />
                  {errors.centerId && (
                    <small className="text-danger">
                      {errors.centerId.message}
                    </small>
                  )}
                </div> */}
                <div className="col-md-6">
                  <label className="form-label">
                    <div className="d-flex align-items-center">
                      Dropdown Name<span className="text-danger fs-9">*</span>
                    </div>
                  </label>
                  <input
                    {...register(`moduleName`, {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    onChange={handleChangeOfInputWithLengthCheck("moduleName")}
                  />
                  <span className="fs-9 d-block mt-1">camelCase</span>
                  {errors.moduleName && (
                    <small className="text-danger">
                      {errors.moduleName.message}
                    </small>
                  )}
                </div>

                <div className="col-12 mt-3">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="d-flex mb-2">
                <div className="ms-auto">
                  <div className="d-flex align-items-center gap-1">
                    {/* <small className="fw-semibold">Export Options</small> */}
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>{" "}
              </div>
              <DataTable
                columns={columns}
                data={filteredDropdownNames}
                pagination
                dense
                customStyles={customTableStyles}
                highlightOnHover={true}
                onChangePage={setCurrentPage}
                onChangeRowsPerPage={setRowsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DropdownNamesSetup;
